import { Component, OnInit, Input, LOCALE_ID, Inject, OnDestroy } from '@angular/core';
import { environment } from '@environments/environment';
import { PassengerComponent } from './passenger.component';
import { SidebarService } from '@ibe/services/ui';
import { Observable, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import * as _ from 'lodash';

import { INDRAPax, INDRATravelDoc } from '@ibe.models/pax.indra.model.lib';
import { INDRABookedTripDetails } from '@ibe.models/booked-trip-details.indra.model.lib';
import { INDRAInfoTicket } from '@ibe.models/pnr-data.indra.model.lib';
import { INDRAFlight } from '@ibe.models/flights.indra.model.lib';
import { formatDate } from '@angular/common';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { INDRAObservatoryService } from '@ibe.services/observatory.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';

import { PAX_TYPE_ADULT_CODE, 
		PAX_TYPE_CHILD_CODE, 
		PAX_TYPE_INFANT_CODE, 
		PAX_TYPE_YOUNG_ADULT_CODE, 
		STATUS_BOOK_PAST_CODE, 
		ANCILLARY_PRODUCT_GROUP_CODE_HOLD_BAGGAGE, 
		SSR_CODE_BAGGAGE_PRIORITY, 
		SSR_CODE_SEAT, 
		ANCILLARY_GROUP_SEAT_RESERVATION_LIST, 
		ANCILLARY_PRODUCT_GROUP_CODE_SEAT_RESERVATION,
		AIR_LINE_CODE_TAP,
		TAP_MILES_AND_GO_FF_TIER_LEVELS,
		TAP_MILES_AND_GO_GOLD,
		TAP_MILES_AND_GO_SILVER,
		TAP_MILES_AND_GO_NAVIGATOR,
		TAP_MILES_AND_GO_MILES,
		TAP_MILES_AND_GO_MILS,
		TAP_HEADER_MILES_AND_GO_GOLD,
		TAP_HEADER_MILES_AND_GO_SILVER,
		TAP_HEADER_MILES_AND_GO_NAVIGATOR,
		TAP_HEADER_MILES_AND_GO_MILES,
		UNCONFIRMED_CODES
		} from '@ibe.config';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { INDRAParallelService } from '@ibe.services/parallel.indra.service';

@Component({
	selector: 'app-passenger',
	templateUrl: './passenger.indra.component.html',
	styleUrls: ['./passenger.component.scss']
})
export class INDRAPassengerComponent extends PassengerComponent
	implements OnInit, OnDestroy {

	private _has_details = false;
	private _passenger: INDRAPax;
	private _flights: INDRAFlight;
	private _index;
	private _booked_trip: INDRABookedTripDetails;
	private _isAward: boolean;

	infoTicket: INDRAInfoTicket;
	travelDoc: INDRATravelDoc;
	_unassignedTickets = {};
	assignedTickets = {};
	_unassignedDocuments = {};
	assignedDocuments = {};
	allSubs: Subscription[] = [];
	docTrue: any;
	userData;
	
	showLogo: boolean;
	logo: any;

	constructor(
		private router: Router,
		private sidebarService: SidebarService,
		@Inject(LOCALE_ID) private locale: string,
		private bfmStorage: INDRABFMDataStorageService,
		private bookingService: INDRABookingService,
		private bookingSearchService: INDRABookingSearchService,
		private observatory: INDRAObservatoryService,
		private ibeAdminService: INDRAIbeAdminService,
		private storage: INDRAStorageService,
		private parallelService: INDRAParallelService,
	) {
		super();
	}

	@Input()
	no_edit = false;
	
	@Input()
	no_detail = false;

	@Input()
	pnr: any;

	@Input()
	set passenger(passenger) {
		this._passenger = passenger;
	}

	get passenger() {
		return this._passenger;
	}

	@Input()
	set index(index) {
		this._index = index;
	}

	get index() {
		return this._index;
	}

	@Input()
	set flights(flights) {
		this._flights = flights;
	}

	get flights() {
		return this._flights;
	}
	
	@Input()
	set isAward(isAward) {
		this._isAward = isAward;
	}
	
	get isAward() {
		return this._isAward;
	}

	@Input()
	set booked_trip(booked_trip) {
		this._booked_trip = booked_trip;
	}
	
	get booked_trip() {
		return this._booked_trip;
	}

	@Input()
	warnings = [];

	@Input()
	isBooking: boolean = false;
	
	isBookingPaymentPage: boolean = false;
	passengerCreated: boolean = false;
    isPaymentMethodLoading$: Observable<boolean> = this.parallelService.isPaymentMethodLoading$;

	ngOnInit() {
		this.userData = this.storage.get('userData');
		this.infoTicket = this._booked_trip.data.infoTicket;
		this.travelDoc = this.INDRA_getTravelDoc();
		// this._has_details = this._passenger.name !== 'undefined';
		this._has_details = !this.isUnsavedPassenger();
		if (this.router.url.includes('/booking/payment') || this.router.url.includes('/time-to-think/payment')) { 
			this.isBookingPaymentPage = true;
		}
		
		const currentBookingSubscription = this.bfmStorage.observableCurrentBooking.subscribe(
			data => {
				if ( data ) {
					this.INDRA_assignValues();
				}
			}
		);
		this.allSubs.push(currentBookingSubscription);
		this.showLogo = false;
	}
	
	INDRA_getDocumentTypes() {
		return [
			{
				text: 'bookingDetails.label.docType.certificateOfCrewMember',
				value: 'AC'
			},
			{
				text: 'bookingDetails.label.docType.identificationDoc',
				value: 'A'
			},
			{
				text: 'bookingDetails.label.docType.passportCard',
				value: 'IP'
			},
			{
				text: 'bookingDetails.label.docType.passengerPassport',
				value: 'P'
			},
			{
				text: 'bookingDetails.label.docType.passport',
				value: '21'
			},
			{
				text: "bookingDetails.label.docType.passport",
				value: '2'
			},
			{
				text: "bookingDetails.label.docType.nationalIdentityCard",
				value: '7'
			},
			{
				text: "bookingDetails.label.docType.nationalIdentityCard",
				value: '5'
			}
		]
	}
	
	INDRA_printDisplayName() {
		// handle scenario for new passenger not saved yet
		if (this.isBookingPaymentPage && this.isUnsavedPassenger()) {
			let key = 'addMoreSidebars.passenger.label.' + this._passenger.typePax;
			return this.INDRA_getTextTranslation(key) + ' ' + this.capitalize(this._passenger.surname);
		}
		
		let salutation = '';
		if (this._passenger.title) {
			salutation = this._passenger.title;
		}
		return this.capitalize(salutation) + ' ' + 
			this.capitalize(this._passenger.name) + ' ' + 
			this.capitalize(this._passenger.surname);
	}
	
	isUnsavedPassenger() {
		// note an unsaved passenger (not yet created for the booking) will always have a number as the surname
		return (this._passenger && this._passenger.surname && !isNaN(this._passenger.surname as any));
	}
	
	capitalize(str: string) {
		if (str.length > 0) {
			return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
		}
		return '';
	}
	
	private getNamePrefix(prefix: string): string {
		if (!prefix || prefix.endsWith('. ')) {
			return prefix;
		}
		return prefix[0].toUpperCase() + prefix.substr(1).toLowerCase() + '. ';
	}
	
	INDRA_printType() {
		let passengerType = '';
		switch (this._passenger.typePax) {
			case PAX_TYPE_ADULT_CODE:
				passengerType = 'bookingDetails.label.adultType';
				break;
			case PAX_TYPE_CHILD_CODE:
				passengerType = 'bookingDetails.label.childType';
				break;
			case PAX_TYPE_INFANT_CODE:
				passengerType = 'bookingDetails.label.infantType';
				break;
			case PAX_TYPE_YOUNG_ADULT_CODE:
				passengerType = 'bookingDetails.label.youngAdultType';
				break;
			default:
				break;
		}
		return passengerType;
	}
	
	INDRA_printTypeCount() {
		return this.INDRA_countPaxBaseOnPaxType();
	}
	
	INDRA_printTicketNumber() {
		if (!this.infoTicket || !this.infoTicket.listTicket) {
			return '';
		}
		
		return '';
	}
	
	INDRA_hasFrequentFlyer() {
		return !(this._passenger.FFnum === undefined || 
			this._passenger.FFnum === null || 
			this._passenger.FFid === undefined || 
			this._passenger.FFid === null);
	}
	
	INDRA_printFrequentFlyer() {
		return this._passenger.FFid + this._passenger.FFnum;
	}
	
	INDRA_printRoute(flight: INDRAFlight) {
		return flight.item.departureLocation.code + ' - ' + flight.item.arrivalLocation.code;
	}
	
	INDRA_printAriaRoute(flight: INDRAFlight) {
		return flight.item.departureLocation.code + this.INDRA_getTextTranslation('bookingDetails.aria.to') + flight.item.arrivalLocation.code;
	}
	
	INDRA_hasFlights() {
		return this._flights !== undefined;
	}
	
	INDRA_hasExtrasLuggageInfo(flight) {
		let fareInfoAncillaries = this.bookingService.INDRA_getFareInformation(
			ANCILLARY_PRODUCT_GROUP_CODE_HOLD_BAGGAGE, flight.item.details.idFlight.toString());

		if (!this.isBooking) {
			let purchasedAncillaries = this.bookingService.INDRA_getPurchasedFeaturesOfFlightCardFirstSegment(
				ANCILLARY_PRODUCT_GROUP_CODE_HOLD_BAGGAGE, flight.item.details.idFlight.toString(),
				flight.item.details.assignedFlightId.toString(), this._passenger.idPax.toString());

			if(purchasedAncillaries.length || fareInfoAncillaries.length) {
				return true;
			}
		}
		return fareInfoAncillaries.length > 0 ? true: false;
	}
	
	INDRA_hasExtrasSeatInfo(flight: INDRAFlight) {
		/* TODO  return flight !== undefined && flight.passengerInfo[this.index] !== undefined && flight.passengerInfo[this.index].seat !== undefined;
		temporarily turned this off to lessen the breaks while models are being updated*/
		return this.INDRA_checkSeats(flight);
	}
	
	INDRA_checkSeats(flight: any) {
		const flightId = flight['item'].details.idFlight;
		const flightItem = flight['item'].details;
		const tierInfoAncillaries = this.booked_trip["tier-information"];
		const segmentIDs = this.INDRA_getSegmentIDs(flightItem);
		let seatFound = false;
		if (this.booked_trip.data.ancillaries.seat) {
			this.booked_trip.data.ancillaries.seat.journey.forEach(seat => {
				if (seat) {
					if (seat.flightId === flightItem.idFlight.toString() && segmentIDs.includes(seat.segmentId)) {
						seat.passengers.forEach(pax => {
							if (pax.paxId === this.passenger.idPax.toString()) {
								pax.ancillaryInfo.forEach(seatInfoItem => {
									if (seatInfoItem.code === SSR_CODE_SEAT) {
											seatFound = true
									}
								});
							}
						});
					}
				}
			});
		}
		let brandHasSeat = false;
		if (this.booked_trip["fare-information"][flightId]) {
			const fareInfoAncillaries = this.booked_trip["fare-information"][flightId].ancillaries;
			brandHasSeat = fareInfoAncillaries.some((element) => {
				return ANCILLARY_GROUP_SEAT_RESERVATION_LIST.includes(element);
			});
		}

		let passenger_tier = this.passenger.tierLevelFF;
		let tierHasSeat = false;
		if (passenger_tier && tierInfoAncillaries && tierInfoAncillaries[passenger_tier]) {
			tierHasSeat = tierInfoAncillaries[passenger_tier].ancillaries.some((element) => {
				return ANCILLARY_GROUP_SEAT_RESERVATION_LIST.includes(element);
			});
		}

		if (!seatFound && (brandHasSeat || tierHasSeat)) {
			seatFound = true;
		}
		return seatFound;
	}
	
	INDRA_getSegmentIDs(flightItem): string[] {
		return flightItem.listSegment.map(segment => segment.idInfoSegment + '');
	}
	
	INDRA_printLuggageInfo(flight) {
		let luggageCount = 0;
		let fareInfoAncillaries: string[] = this.bookingService.INDRA_getFareInformation(
			ANCILLARY_PRODUCT_GROUP_CODE_HOLD_BAGGAGE, flight.item.details.idFlight.toString());
		if (this._passenger.typePax === PAX_TYPE_INFANT_CODE) {
			// sets the limitation for infant
			if (fareInfoAncillaries.length > 0) {
				luggageCount = 1;
			}
		} else {
			fareInfoAncillaries.forEach(ancillaryItem => {
				if (ancillaryItem.includes('x2')) {
					luggageCount = luggageCount + 2;
				} else if (ancillaryItem.includes('x3')) {
					luggageCount = luggageCount + 3;
				} else if (ancillaryItem !== SSR_CODE_BAGGAGE_PRIORITY) {
					luggageCount++;
				}
			});
		}

		if (this.isBooking) {
			let addedAncillaries = this.bookingSearchService.INDRA_getAddedFeaturesOfFlightCardFirstSegment(
				ANCILLARY_PRODUCT_GROUP_CODE_HOLD_BAGGAGE, flight.item.details.idFlight,
				flight.item.details.assignedFlightId, this._passenger.idPax);
			addedAncillaries.forEach(ancillaryItem => {
				if (ancillaryItem.code.includes('x2')) {
					luggageCount = luggageCount + 2;
				} else if (ancillaryItem.code.includes('x3')) {
					luggageCount = luggageCount + 3;
				} else if (ancillaryItem.code !== SSR_CODE_BAGGAGE_PRIORITY) {
					luggageCount = luggageCount + ancillaryItem.count;
				}
			});
		} else {
			let puchasedAncillaries = this.bookingService.INDRA_getPurchasedFeaturesOfFlightCardFirstSegment(
				ANCILLARY_PRODUCT_GROUP_CODE_HOLD_BAGGAGE, flight.item.details.idFlight.toString(),
				flight.item.details.assignedFlightId.toString(), this._passenger.idPax.toString());
			puchasedAncillaries.forEach(ancillaryItem => {
				if (!UNCONFIRMED_CODES.includes(Number(ancillaryItem.status))) {
					if (ancillaryItem.code.includes('x2')) {
						luggageCount = luggageCount + 2;
					} else if (ancillaryItem.code.includes('x3')) {
						luggageCount = luggageCount + 3;
					} else if (ancillaryItem.code !== SSR_CODE_BAGGAGE_PRIORITY) {
						luggageCount = luggageCount + ancillaryItem.count;
					}
				}
			});
		}

		let ancillariesTier = this.bookingService.INDRA_getPassengersTierBenefits(ANCILLARY_PRODUCT_GROUP_CODE_HOLD_BAGGAGE);
		let paxAncillary = Object.assign({}, ...ancillariesTier);
		if (paxAncillary) {
			paxAncillary[this._passenger.idPax].forEach((ancillaryItem) => {
				if (ancillaryItem.includes('x2')) {
					luggageCount = luggageCount + 2;
				} else if (ancillaryItem.includes('x3')) {
					luggageCount = luggageCount + 3;
				} else if (ancillaryItem !== SSR_CODE_BAGGAGE_PRIORITY) {
					luggageCount++;
				}
			})
		}
		return luggageCount > 0 ? luggageCount + 'x' : luggageCount;
	}
	
	INDRA_printSeatInfo(flight: INDRAFlight) {
		/* TODO
		return flight.passengerInfo[this.index].seat;
		temporarily turned this off to lessen the breaks while models are being updated*/
		// return flight.passengerInfo[this.index].seat;
	}
	
	INDRA_hasPassengerDetails(): boolean {
		return this._has_details;
	}
	
	INDRA_hasPassengerDocuments() {
		return this.travelDoc !== undefined;
	}

	INDRA_hasDetails(): boolean {
		if (this._has_details && !this.passengerCreated) {
			this.parallelService.INDRA_setIsPassengerCreated(true);
			this.passengerCreated = true;
		}

		return this._has_details;
	}

	INDRA_getWarnings() {
		return this.warnings;
	}
	
	INDRA_hasDocumentOrFFnum() {
		return ((this.INDRA_hasDocument() ||this.INDRA_hasDocumentExpirationDate()) && this.INDRA_hasPassengerDocuments()) ||
			this.INDRA_hasFrequentFlyerNumber();
	}
	
	INDRA_printWarning(): boolean {
		/* TODO return this._passenger.missing_info[0].type;
		temporarily turned this off to lessen the breaks while models are being updated*/
		return false;
	}
	
	INDRA_printLinkClasses() {
		return {
			display: !this._has_details ? 'block' : 'flex'
		};
	}
	
	// Check if booking status is pending
	INDRA_isPending() {
		return this._booked_trip.data.statusBook.toLowerCase() === STATUS_BOOK_PAST_CODE;
	}
	
	// Open Sidebar
	INDRA_handleOpenDetailsSidebar() {
		if (this.router.url.includes('/booking/payment') || this.router.url.includes('/time-to-think/payment')) {
			this.INDRA_handleOpenNewPassengerSidebarEdit();
		} else {
			this.sidebarService.openSidebar(['passengers', { pnr: this.pnr, id: this._passenger.idPax }]);
		}
	}
	
	INDRA_handleOpenNewPassengerSidebar() {
		this.sidebarService.openSidebar(['new-passenger', { pnr: this.pnr, id: this._passenger.idPax, edit: false, isNew: this.passenger.isNew, isAward: this.isAward }]);
	}

	INDRA_handleOpenNewPassengerSidebarEdit() {
		this.sidebarService.openSidebar(['new-passenger', { pnr: this.pnr, id: this._passenger.idPax, edit: true, isNew: this.passenger.isNew, isAward: this.isAward }]);
	}
	
	INDRA_handleOpenIncludedSidebar(flight) {
		this.sidebarService.openSidebar(['passenger-included', { flight: flight.item.details.assignedFlightId, pnr: this.pnr, id: this._passenger.idPax }]);
	}
	
	// additional
	INDRA_printPassportNumber() {
		const maskCount = this.travelDoc.docNum.length - 2;
		const mask = '*'.repeat(maskCount);
		return mask + this.travelDoc.docNum.substr(-2, this.travelDoc.docNum.length);
	}
	
	INDRA_printDocumentNumber() {
		// to prevent issues where the document number is less than the unmasked portion of the number
		if (this.travelDoc.docNum && this.travelDoc.docNum.length > 2) {
			const maskCount = this.travelDoc.docNum.length - 2;
			const mask = '*'.repeat(maskCount);
			return mask + this.travelDoc.docNum.substr(-2, this.travelDoc.docNum.length);
		}
		else {
			return this.travelDoc.docNum;
		}
	}
	
	INDRA_hasPassport(): boolean {
		return !!this.travelDoc && this.travelDoc.docNum && this.travelDoc.docType === '21';
	}

	INDRA_hasDocument(): boolean {
		return (this.travelDoc && this.travelDoc.docNum ? true : false);
	}

	INDRA_hasPassportExpirationDate(): boolean {
		return this.INDRA_hasPassport() && !!this.travelDoc.expiryDate;
	}

	INDRA_hasDocumentExpirationDate(): boolean {
		return (this.travelDoc && this.travelDoc.expiryDate &&  this.travelDoc.expiryDate.length > 0 ? true : false);
	}

	INDRA_hasFrequentFlyerNumber(): boolean {
		return !!this._passenger.FFnum;
	}
	
	INDRA_printPassportExpiry() {
		if (this.travelDoc) {
			if (this.travelDoc.expiryDate === '' || !this.travelDoc.expiryDate) {
				return this.travelDoc.expiryDate;
			}
			return formatDate(this.travelDoc.expiryDate, '**/**/yyyy', this.locale);
		}
	}

	INDRA_printDocumentExpiry() {
		if (this.travelDoc) {
			if (this.travelDoc.expiryDate === '') {
				return this.travelDoc.expiryDate;
			}
			return formatDate(this.travelDoc.expiryDate, '**/**/yyyy', this.locale);
		}
	}

	INDRA_getTicketNumber() {
		// TODO add logic to avoid displaying ticket number if component is used during TTT payment (see component's TAP ts file for reference)
		
		if (!this.infoTicket || !this.infoTicket.listTicket || !this._passenger) {
			return '';
		}
		if (this.assignedTickets[this.index]) {
			return this.assignedTickets[this.index];
		}

		// Check if there is only one ticket using the idPax
		const ticketsByPaxId = this.infoTicket.listTicket.filter(p => p.idPax === this._passenger.idPax);
		if (ticketsByPaxId.length === 1) {
			this.assignedTickets[this.index] = ticketsByPaxId[0].ticket;
			return ticketsByPaxId[0].ticket;
		}

		const id = this._passenger.idPax + '';
		// If we have more than one, first we check if there is an unassigned ticket for this id
		if (!this._unassignedTickets[id]) {
			// If there is no entry, then this is the first ID
			this._unassignedTickets[id] = ticketsByPaxId;
		}
		// If we have unassigned tickets, return the first one
		if (this._unassignedTickets[id].length > 0) {
			this.assignedTickets[this.index] = this._unassignedTickets[id].shift().ticket;
			return this.assignedTickets[this.index];
		}

		// If there is no unassigned tickets, try the regular way, by idPax
		const ticketInfo = this.infoTicket.listTicket.find(p => p.idPax === this._passenger.idPax);
		if (ticketInfo) {
			this.assignedTickets[this.index] = ticketInfo.ticket;
			return ticketInfo.ticket;
		}

		return '';
	}
	
	INDRA_getTravelDoc() {
		const listPax = this._booked_trip.data.infoPax.listPax;
		const passenger = this._passenger;
		if (!listPax || !passenger) {
			return {};
		}
		if (this.assignedDocuments[this.index]) {
			return this.assignedDocuments[this.index];
		}
		let travelDocsByPaxId = [];
		const id = passenger.idPax + '';
		// If we have more than one, first we check if there is an unassigned docs for this id
		if (!this._unassignedDocuments[id]) {
			// Check if there is only one travel doc using the idPax
			// FAILS IN IE BROWSERS -> travelDocsByPaxId = listPax.filter(p => p.idPax === passenger.idPax).flatMap(p => p.listTravelDoc);
			travelDocsByPaxId = listPax.filter(p => p.idPax === passenger.idPax).reduce((acc, pax) => acc.concat(pax.listTravelDoc), []);
			if (travelDocsByPaxId.length === 1) {
				this.assignedDocuments[this.index] = travelDocsByPaxId[0];
				return travelDocsByPaxId[0];
			}
			// If there is no entry, then this is the first ID
			this._unassignedDocuments[id] = travelDocsByPaxId;
		}
		// If we have unassigned tickets, return the first one
		if (this._unassignedDocuments[id].length > 0) {
			this.assignedDocuments[this.index] = this._unassignedDocuments[id].shift();
			return this.assignedDocuments[this.index];
		}
		// If there is no unassigned tickets, try the regular way, by idPax
		if (travelDocsByPaxId && travelDocsByPaxId.length > 0) {
			this.assignedDocuments[this.index] = travelDocsByPaxId[0];
			return travelDocsByPaxId;
		}
		return null;
	}
	
	INDRA_countPaxBaseOnPaxType() {
		let index = 0;
		const test = this.booked_trip.data.infoPax.listPax.filter(p => p.typePax === this._passenger.typePax);
		index = test.findIndex(x => x.idPax == this.passenger.idPax);
		return index + 1;
	}
	
	INDRA_printDocumentType(): any {
		if (this.travelDoc) {
			const passengerDoctype = this.INDRA_getDocumentTypes().find( item => Object.is( item.value, this.travelDoc.docType ));
			if (passengerDoctype && passengerDoctype.text) {
				this.docTrue = true;
				this.observatory.setData('notificationPassenger', this.docTrue );
				return passengerDoctype.text;
			} else {
				return 'bookingDetails.label.docType.nationalIdentityCard';
			}

		}
	}
	
	INDRA_assignValues() {
		if (this.bfmStorage.INDRA_getActiveBookInfoPax()) {
			const infoPax = this.bfmStorage.INDRA_getActiveBookInfoPax();
			let passengerPaxIndex = infoPax.listPax.findIndex(item => item.idPax == this._passenger.idPax);
			if (passengerPaxIndex != -1) {
				const booked_trip = _.cloneDeep(this.booked_trip);
				booked_trip.data.infoPax = infoPax;
				this.booked_trip = booked_trip;
				this.travelDoc = infoPax.listPax[passengerPaxIndex].listTravelDoc[0];
				this.passenger = infoPax.listPax[passengerPaxIndex];
				this.INDRA_printPassportExpiry();
			}
		}
	}
	
	ngOnDestroy() {
		for (let sub of this.allSubs) {
			sub.unsubscribe();
		}
	}

	INDRA_getTextTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}
	
	INDRA_displayLogo() {
		const ffId = this._passenger.FFid;
		const ffTierLevel = this._passenger.tierLevelFF; 
		if (ffId && ffId === AIR_LINE_CODE_TAP && 
			ffTierLevel && TAP_MILES_AND_GO_FF_TIER_LEVELS.includes(ffTierLevel)) {
			this.showLogo = true;
			switch (ffTierLevel) {
				case TAP_MILES_AND_GO_GOLD:
					this.logo = 'loyalty--miles_go_gold'; break;
				case TAP_MILES_AND_GO_SILVER:
					this.logo = 'loyalty--miles_go_silver'; break;
				case TAP_MILES_AND_GO_NAVIGATOR:
					this.logo = 'loyalty--navigator'; break;
				case TAP_MILES_AND_GO_MILES:
				case TAP_MILES_AND_GO_MILS:
					this.logo = 'loyalty--miles_go'; break;
				default:
					this.logo = '';
			}
		} else {
			this.showLogo = false;
		}
		return this.showLogo;
	}

	INDRA_warningSpace() {
		if (!this.passenger.isNew || this.passenger.typePax == PAX_TYPE_INFANT_CODE) {
			return { 'visibility': 'hidden'};
		} else {
			return { 'visibility': 'visible'};
		}
	}
}
